import React, { useCallback, useState } from "react";
import { Avatar, Menu, MenuButton } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { AccountSettingsBootstrap } from "./components/AccountSettingsBootstrap";
import { CurrentUserPopup } from "./components/CurrentUserPopup";
import { AccountSettingsModal } from "./components/AccountSettingsModal";
import { colours } from "@/utils/themeUtils";
import useStore from "@/stores/index";
import { isChatFeatureEnabled } from "@/js/utils/chatUtils";

export function UserSessionDropdown(): JSX.Element {
	const { t } = useTranslation();
	const [menuDrivenAccountOpen, setMenuDrivenAccountOpen] = useState(false);
	const accountSettingsOpenForChatUsername = useStore((s) => s.chat.accountSettingsOpenForChatUsername);
	const dismissAccountSettingsChatPrompt = useStore((s) => s.chat.dismissAccountSettingsChatPrompt);

	const isAccountModalOpen = menuDrivenAccountOpen || accountSettingsOpenForChatUsername;
	const usernamePromptMode = accountSettingsOpenForChatUsername && isChatFeatureEnabled();

	const handleCloseAccountModal = useCallback(() => {
		setMenuDrivenAccountOpen(false);
		dismissAccountSettingsChatPrompt();
	}, [dismissAccountSettingsChatPrompt]);

	return (
		<>
			<AccountSettingsBootstrap />
			<Menu id="current-user-popup">
				<MenuButton className="user-icon" aria-label={t("account.userSettingsAria")}>
					<Avatar size="sm" bg={colours.neutrals[300]} color={colours.neutrals[50]} border={"2px solid rgba(255, 255, 255, 0.7)"} />
				</MenuButton>
				<CurrentUserPopup onOpenAccountSettings={() => setMenuDrivenAccountOpen(true)} />
			</Menu>
			<AccountSettingsModal isOpen={isAccountModalOpen} onClose={handleCloseAccountModal} usernamePromptMode={usernamePromptMode} />
		</>
	);
}
